






























































































































































































































































































































































































import "animate.css";
import * as echarts from "echarts";
import JQuery from "jquery";
import wx from "weixin-js-sdk";
import axios from "axios";
import myvideo from "../components/myvideo.vue";

import wxshare from "../components/share.vue";
import indexPop from "../components/indexPop.vue";
import downLoadApp from "../components/downloadApp.vue";
import { Component, Vue, Inject } from "vue-property-decorator";
import {
  getIndexCjType,
  getRecommendData,
  getCcfInfo,
  getChexing,
  getRecInfo,
  getHeaderData,
} from "../api/index";
@Component({
  components: {
    wxshare,
    downLoadApp,
    myvideo,
    indexPop,
  },
})
export default class index extends Vue {
  // @Inject('weixinLogin') private weixinLogin:any
  $route: any;
  $store: any;
  $router: any;
  $wx: any;
  indexPopTF: boolean = false;
  videoInfo: any = {};
  myVideoTF: any = false;
  downloadTF: any = false;
  activeTab: any = 0;
  shareTipTF: any = false;
  wordScrollTop: number = 70;
  wordIndex: any = null;
  ccfMcnId: number = 111;
  ccfUserId: number = 0;
  indexData: any = {};
  xzcxTkTF1: boolean = false;
  xzcxTkTF: boolean = false;
  swipeData: any[] = ["a", "b", "c"];
  cjzData: any = [];
  swiperIndex: number = 0;
  tabIndex: number = 0;
  conSwipeData: any[] = ["宝马X3", "凯迪拉克CT6", "捷途X70"];
  conSwipeIndex: any = 0;
  tabData: any[] = [];
  cxData: any[] = [];
  cxData1: any = {};
  cxSelectData: any = [];
  infoName: any = 0;
  // 首页信息流
  pageNo: any = 1;
  pageSize: any = 10;
  entityType: any = 0;
  subType: any = 0;
  brandIds: any[] = [];
  clubIds: any[] = [];
  recData: any[] = [];
  loading: any = false;
  finished: any = false;

  //视频信息流
  pageNoVideo: any = 1;
  pageSizeVideo: any = 10;
  recVideoData: any[] = [];
  loadingVideo: any = false;
  finishedVideo: any = false;
  entityTypeVideo: any = 0;
  subTypeVideo: any = 0;
  // 图文信息流
  pageNoText: any = 1;
  pageSizeText: any = 10;
  recTextData: any[] = [];
  loadingText: any = false;
  finishedText: any = false;
  entityTypeText: any = 5;
  subTypeText: any = 2;
  //短视频信息流
  pageNoSVideo: any = 1;
  pageSizeSVideo: any = 10;
  recSVideoData: any[] = [];
  loadingSVideo: any = false;
  finishedSVideo: any = false;
  entityTypeSVideo: any = 0;
  subTypeSVideo: any = 0;
  url1: any = encodeURIComponent(location.href.split("#")[0]);
  wxShareUrl: any = "";
  userAgent: any = "";
  token: any;
  isLoading: boolean = false;
  data: any;
  firstTF: any = true;
  totalCount: any = 0;
  totalVideoCount: any = 0;
  totalSVideoCount: any = 0;
  totalTextCount: any = 0;
  mounted() {
    this.data = {
      title: "拆车坊",
      videoCover:
        "https://img1.chexun.com/chexunimg/erpimg/2019/0620/icon_default_0af581c1ec7c4d418e9e1a48b91b9815.png",
      description: "车海茫茫，眼花缭乱；靠不靠谱，拆给你看。",
    };
    this.wxShareUrl = window.location.href;

    this.userAgent = navigator.userAgent.toLowerCase();
    // 获取首页中部拆解数据
    this.getIndexData();
    // 获取拆解中数据
    this.getCjzData();
    // 获取拆车坊信息
    this.getCcfInfoData();
    this.getCcfHeaderData();
  }
  onRefresh() {
    this.data = {
      title: "拆车坊",
      videoCover:
        "https://img1.chexun.com/chexunimg/erpimg/2019/0620/icon_default_0af581c1ec7c4d418e9e1a48b91b9815.png",
      description: "车海茫茫，眼花缭乱；靠不靠谱，拆给你看。",
    };
    this.wxShareUrl = window.location.href;
    setTimeout(() => {
      this.cxSelectData = [];
      this.brandIds = [];
      this.clubIds = [];
      this.recData = [];
      this.recVideoData = [];
      this.recTextData = [];
      this.recSVideoData = [];
      this.pageNo = 1;
      this.pageNoVideo = 1;
      this.pageNoText = 1;
      this.pageNoSVideo = 1;
      this.indexData = {};
      this.swipeData = [];
      this.activeTab = 0;
      if (this.infoName == 2) {
        this.infoName = 0;
      } else {
        this.infoName = 0;
        this.getRecData();
      }
      // 获取首页中部拆解数据
      this.getIndexData();
      // 获取拆解中数据
      this.getCjzData();
      // 获取拆车坊信息
      this.getCcfInfoData();
      this.getCcfHeaderData();
      this.isLoading = false;
    }, 1000);
  }

  changeVideo(val: any) {
    this.myVideoTF = val;
  }
  changeShare(val: any) {
    this.shareTipTF = val;
  }
  changeDownload(val: any) {
    this.downloadTF = val;
  }
  goHeaderPage(item: any) {
    window.location.href = item.url;
  }
  goIndexPage() {
    window.location.reload();
  }
  goHistory() {
    if (document.referrer) {
      window.history.go(-1);
    } else {
      window.location.reload();
    }
  }
  changIndexPopTF(val: any) {
    this.indexPopTF = val;
  }
  //获取拆车坊头部信息
  getCcfHeaderData() {
    let params: any = {
      type: 1,
    };
    getHeaderData(params).then((res: any) => {
      this.swipeData = res.data.list;
    });
  }
  //获取拆车坊信息
  getCcfInfoData() {
    let params: any = {
      mcnId: this.ccfMcnId,
      token: this.token,
    };
    getCcfInfo(params).then((res: any) => {
      this.ccfUserId = res.data.ucUserId;
      this.tabData = res.data.tabList;
    });
  }
  //分享
  shareUrl(item: any, params: any) {
    if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
      this.shareTipTF = true;
      if (!params) {
        let detailTime = item.createTime.substring(0, 10);
        this.wxShareUrl =
          window.location.origin + `/${detailTime}/${item.id}.html`;
        this.wxShareData(item);
      } else {
        this.wxShareUrl = window.location.href;
      }
    } else {
      this.downloadTF = true;
    }
  }
  // 微信分享
  wxShareData(typeData: any) {
    if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
      var that = this;
      JQuery.ajax({
        type: "get",
        url: "http://reg.chexun.com/api/WeiXinInfo.ashx",
        cache: false,
        dataType: "jsonp",
        data: { url: that.wxShareUrl },
        jsonpCallback: "funcweixin",
        success: function (data: any) {
          wx.config({
            debug: false, // true开启调试模式,pc端会console.log手机端会alert
            appId: data.appId, // 必填，公众号的唯一标识，填自己的！
            timestamp: data.wxinfo.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr: data.wxinfo.nonceStr, // 必填，生成签名的随机串
            signature: data.wxinfo.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
          });
          wx.ready(function () {
            //分享到朋友圈
            wx.updateTimelineShareData({
              title: typeData.title, // 分享时的标题
              link: that.wxShareUrl, // 分享时的链接
              imgUrl: typeData.videoCover, // 分享时的图标
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                // alert("取消分享");
              },
            });
            //分享给朋友
            wx.updateAppMessageShareData({
              title: typeData.title,
              desc: typeData.description,
              link: that.wxShareUrl,
              imgUrl: typeData.videoCover,
              success: function () {
                console.log("分享成功");
                //alert("分享成功");
              },
              cancel: function () {
                //alert("取消分享");
              },
            });
          });
        },
        error: function () {
          alert("error");
        },
      });
    }
  }
  //跳转到拆解详情页
  goCjDetail(params: any) {
    this.$router.push({
      path: "/cjDetail",
      query: {
        reportId: params.reportId,
      },
    });
  }
  //跳转到拆解车型列表
  goCjCarType() {
    this.$router.push({
      path: "/cjCarType",
    });
  }
  //改变信息流tab
  changeTabIndex(params: any, index: any) {
    this.tabIndex = index;
    if (params.entityType == 0) {
      this.infoName = 0;
      this.entityType = params.entityType;
      this.subType = params.subType;
      if (this.recData.length == 0) {
        this.loading = true;
        this.getRecData();
      }
    } else if (params.entityType == 2 && params.subType == 2) {
      this.infoName = 1;
      this.entityTypeVideo = params.entityType;
      this.subTypeVideo = params.subType;
      if (this.recVideoData.length == 0) {
        this.loadingVideo = true;
        this.getRecVideoData();
      }
    } else if (params.entityType == 2 && params.subType == 1) {
      // if (this.recSVideoData.length == 0) {
      //   this.loadingSVideo = true;
      // }
      this.infoName = 2;
      this.recSVideoData = [];
      this.pageNoSVideo = 1;
      this.entityTypeSVideo = params.entityType;
      this.subTypeSVideo = params.subType;
      // if (this.recSVideoData.length == 0) {
      //   setTimeout(() => {
      //     this.getRecSVideoData();
      //   }, 300);
      // }
      if (this.recSVideoData.length == 0) {
        //使用waterfall的onload时需要加此判断
        this.getRecSVideoData();
      }
    } else if (params.entityType == 5) {
      this.infoName = 3;
      this.entityTypeText = params.entityType;
      this.subTypeText = params.subType;
      if (this.recTextData.length == 0) {
        this.loadingText = true;
        this.getRecTextData();
      }
    }
  }
  //跳转到详情页
  goDetail(params: any, index: any) {
    if (index == 1) {
      this.$router.push({
        path: "/detail",
        query: {
          entityId: params.id,
        },
      });
    } else {
      if (params.entityType == 1) {
        this.myVideoTF = true;
        this.videoInfo = params;
      } else {
        let modelId;
        switch (index) {
          case 0:
            modelId = params.id;
            break;
        }
        let detailTime;
        if (params.creationTime) {
          detailTime = params.creationTime.substring(0, 10);
        } else {
          detailTime = params.createTime.substring(0, 10);
        }
        this.$router.push({
          path: `/${detailTime}/${params.id}.html`,
        });
      }
    }

    // window.location.href = `http://m.chexun.com/app/appnews#/?entityId=${modelId}`;
    // window.location.href = 'http://172.18.90.8:8081/#/?entityId=113644899'
  }
  //全部信息流无限加载
  onLoad() {
    // setTimeout(() => {
    //   if (this.recData.length >= this.totalCount && this.recData.length !== 0) {
    //     this.finished = true;
    //   } else {
    //     this.getRecData();
    //   }
    // }, 300);
    this.loading = true;
    this.getRecData();
  }
  //推荐信息流-全部
  getRecData() {
    let params: any = {
      classId: this.ccfUserId,
      classType: 12,
      dataType: 1,
      entityType: this.entityType,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      subType: this.subType,
      token: this.token,
      userId: this.ccfUserId,
      clubs: {
        brandIds: this.brandIds,
        clubIds: this.clubIds,
      },
    };
    getRecInfo(params).then((res: any) => {
      if (res.data.count == undefined) {
        this.loading = false;
        this.finished = true;
      } else {
        this.totalCount = res.data.count;
        this.recData = this.recData.concat(res.data.list);
        this.loading = false;
        if (this.recData.length >= this.totalCount) {
          this.finished = true;
        }
        this.pageNo = this.pageNo + 1;
      }

      // if (res.data.list.length < 10) {
      //   this.finished = true;
      // } else {
      //   this.pageNo += 1;
      // }
    });
  }
  //视频信息流无限加载
  onLoadVideo() {
    // setTimeout(() => {
    //   if (
    //     this.recVideoData.length >= this.totalVideoCount &&
    //     this.recVideoData.length !== 0
    //   ) {
    //     this.finishedVideo = true;
    //   } else {
    //     this.getRecVideoData();
    //   }
    // }, 300);
    this.loadingVideo = true;
    this.getRecVideoData();
  }

  //推荐信息流-视频
  getRecVideoData() {
    let params: any = {
      classId: this.ccfUserId,
      classType: 12,
      dataType: 1,
      entityType: this.entityTypeVideo,
      pageNo: this.pageNoVideo,
      pageSize: this.pageSizeVideo,
      subType: this.subTypeVideo,
      token: this.token,
      userId: this.ccfUserId,
      clubs: {
        brandIds: this.brandIds,
        clubIds: this.clubIds,
      },
    };
    getRecInfo(params).then((res: any) => {
      this.loadingVideo = false;
      this.totalVideoCount = res.data.count;
      this.recVideoData = this.recVideoData.concat(res.data.list);
      if (this.recVideoData.length >= this.totalVideoCount) {
        this.finishedVideo = true;
      }
      this.pageNoVideo = this.pageNoVideo + 1;
      // if (res.data.list.length < 10) {
      //   this.finishedVideo = true;
      // } else {
      //   this.pageNoVideo += 1;
      // }
    });
  }
  //图文信息流无限加载
  onLoadText() {
    setTimeout(() => {
      if (
        this.recTextData.length >= this.totalTextCount &&
        this.recTextData.length !== 0
      ) {
        this.finishedText = true;
      } else {
        this.getRecTextData();
      }
    }, 300);
  }
  //推荐信息流-图文
  getRecTextData() {
    let params: any = {
      classId: this.ccfUserId,
      classType: 12,
      dataType: 1,
      entityType: this.entityTypeText,
      pageNo: this.pageNoText,
      pageSize: this.pageSizeText,
      subType: this.subTypeText,
      token: this.token,
      userId: this.ccfUserId,
      clubs: {
        brandIds: this.brandIds,
        clubIds: this.clubIds,
      },
    };
    getRecInfo(params).then((res: any) => {
      this.loadingText = false;
      this.totalTextCount = res.data.count;
      this.recTextData = this.recTextData.concat(res.data.list);
      // if (res.data.list.length < 10) {
      //   this.finishedText = true;
      // } else {
      //   this.pageNoText += 1;
      // }
      this.pageNoText += 1;
    });
  }
  //短视频信息流无限加载
  onLoadSVideo() {
    if (!this.finishedSVideo) {
      this.finishedSVideo = true;
      //用waterfall的onload时需要加判断 和 this.finishedSVideo = true
      this.getRecSVideoData();
    }
  }
  //推荐信息流-短视频
  getRecSVideoData() {
    let params: any = {
      classId: this.ccfUserId,
      classType: 12,
      dataType: 1,
      entityType: this.entityTypeSVideo,
      pageNo: this.pageNoSVideo,
      pageSize: this.pageSizeSVideo,
      subType: this.subTypeSVideo,
      token: this.token,
      userId: this.ccfUserId,
      clubs: {
        brandIds: this.brandIds,
        clubIds: this.clubIds,
      },
    };
    getRecInfo(params).then((res: any) => {
      this.loadingSVideo = false;
      this.recSVideoData = this.recSVideoData.concat(res.data.list);
      this.finishedSVideo = false;
      if (res.data.list.length < 10) {
        this.finishedSVideo = true;
      } else {
        this.pageNoSVideo += 1;
      }
    });
  }
  //关闭选择车型弹框
  closeXzcxTk() {
    this.xzcxTkTF = false;
    this.wordIndex = null;
  }
  //打开车型弹框
  opxzcxTk() {
    this.xzcxTkTF = true;
    this.getChexingData();
  }
  // 打开二级车型弹框
  opxzcxTk1(params: any) {
    this.xzcxTkTF1 = true;
    this.cxData1 = params;
  }
  //监听车型弹框滚动距离
  scrollEvent() {
    this.wordScrollTop = (this.$refs.xzcxTKRef as any).scrollTop + 70;
  }
  //点击二级车型弹框选项
  selectOption(params: any) {
    this.cxSelectData = [];
    this.brandIds = [];
    this.clubIds = [];
    this.cxSelectData.push(params);
    this.clubIds.push(params.clubId);
    this.brandIds.push(this.cxData1.brandId);
    this.xzcxTkTF1 = false;
    this.xzcxTkTF = false;
    this.recData = [];
    this.recVideoData = [];
    this.recTextData = [];
    this.recSVideoData = [];
    this.pageNo = 1;
    this.pageNoVideo = 1;
    this.pageNoText = 1;
    this.pageNoSVideo = 1;
    this.activeTab = 0;
    this.infoName = 0;
    this.loading = true;
    this.totalCount = 0;
    this.getRecData();
    // switch (this.infoName) {
    //   case 0:
    //     this.loading = true;
    //     this.getRecData();
    //     break;
    //   case 1:
    //     this.loadingVideo = true;
    //     this.getRecVideoData();
    //     break;
    //   case 2:
    //     this.getRecSVideoData();
    //     break;
    //   case 3:
    //     this.loadingText = true;
    //     this.getRecTextData();
    //     break;
    // }
  }
  //删除选中车型的某一项
  removeOption(index: any) {
    // this.cxSelectData.splice(index, 1);
    // this.brandIds.splice(index, 1);现在只能单选，先走removeAllOption方法
    this.removeAllOption();
  }
  //清空全部车型
  removeAllOption() {
    this.cxSelectData = [];
    this.brandIds = [];
    this.clubIds = [];
    this.recData = [];
    this.recVideoData = [];
    this.recTextData = [];
    this.recSVideoData = [];
    this.pageNo = 1;
    this.pageNoVideo = 1;
    this.pageNoText = 1;
    this.pageNoSVideo = 1;
    this.finished = false;
    this.finishedVideo = false;
    this.finishedText = false;
    this.finishedSVideo = false;
    this.activeTab = 0;
    this.infoName = 0;
    this.loading = true;
    this.totalCount = 0;
    this.getRecData();
    // switch (this.infoName) {
    //   case 0:
    //     this.loading = true;
    //     this.getRecData();
    //     break;
    //   case 1:
    //     this.loadingVideo = true;
    //     this.getRecVideoData();
    //     break;
    //   case 2:
    //     this.getRecSVideoData();
    //     break;
    //   case 3:
    //     this.loadingText = true;
    //     this.getRecTextData();
    //     break;
    // }
  }

  //获取车型数据
  getChexingData() {
    let params: any = {
      mcnId: this.ccfMcnId,
      userId: this.ccfUserId,
      isMe: 0,
      token: this.token,
    };
    getChexing(params).then((res: any) => {
      this.cxData = res.data.data;
    });
  }
  //改变车型列表字母索引
  changeWordIndex(index: any) {
    this.wordIndex = index;
    let optionArray: any = this.$refs.optionLabel;
    optionArray[index].scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
  //获取首页中部拆解数据
  getIndexData() {
    let params: any = {
      voteType: 0,
      pageNo: 1,
      pageSize: 2,
      disStatus: 4,
      brandId: "",
      sortType: "",
    };
    getIndexCjType(params).then((res: any) => {
      this.indexData = res.data;
      this.$nextTick(() => {
        this.wxShareData(this.data);
        for (let i in this.indexData.list) {
          this.indexData.list[i].totalScore = [];
          for (let y in this.indexData.list[i].firstScore) {
            this.indexData.list[i].totalScore.push(
              this.indexData.list[i].firstScore[y].firstScore
            );
          }
          var chartDom = document.getElementById(
            `indexMain${i}`
          ) as HTMLElement;
          var myChart = echarts.init(chartDom);
          myChart.setOption(this.initIndexMain(this.indexData.list[i]));
        }
      });
    });
  }
  //获取拆解中数据
  getCjzData() {
    let params: any = {};
    getRecommendData(params).then((res: any) => {
      this.cjzData = res.data.disassemble;
      for (let i in this.cjzData) {
        this.cjzData[i].titleName =
          this.cjzData[i].name + " " + this.cjzData[i].modelName;
      }
    });
  }
  //改变头部swipe的索引
  changeSwipe(index: any) {
    this.swiperIndex = index;
  }
  //初始化雷达图
  initIndexMain(params: any) {
    return {
      title: [
        {
          text: params.score,
          left: "25%",
          top: "center",
          textStyle: {
            fontSize: 12,
            color: "rgba(18, 24, 38, 1)",
          },
        },
        {
          text: "分",
          left: "50%",
          top: "center",
          textStyle: {
            fontSize: 8,
            color: "rgba(18, 24, 38, 1)",
          },
        },
      ],
      radar: [
        {
          indicator: [
            {
              name: "",
              max: 100,
            },
            {
              name: "",
              max: 100,
            },
            {
              name: "",
              max: 100,
            },
            {
              name: "",
              max: 100,
            },
            {
              name: "",
              max: 100,
            },
            {
              name: "",
              max: 100,
            },
          ],
          center: ["50%", "50%"], //位置
          radius: 30,
          startAngle: 90,
          splitNumber: 6,
          shape: "polygon",
          nameGap: 5,
          name: {
            formatter: "{value}",
            textStyle: {
              color: "rgba(239, 244, 255, 1)",
              fontSize: 12,
            },
          },
          splitArea: {
            areaStyle: {
              color: [
                "rgba(218, 230, 250, 1)",
                "rgba(218, 230, 250, 1)",
                "rgba(165, 178, 200, 0.6)",
                "rgba(78,83, 92, 0.75)",
                "rgba(70,77, 88, 0.4)",
                "rgba(116,125,141,0.3)",
              ],
              // shadowColor: 'rgba(70, 77, 88, 0.4)',
              // shadowBlur: 10
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0)",
            },
          },
        },
      ],
      series: [
        {
          name: "雷达图",
          type: "radar",
          emphasis: {
            lineStyle: {
              width: 0,
            },
          },
          lineStyle: {
            width: 0,
          },
          data: [
            {
              value: params.totalScore,
              name: "车辆维度图",
              symbolSize: 4,
              areaStyle: {
                color: "rgba(161, 175, 202, 1)",
              },
              itemStyle: {
                color: "rgba(159, 178, 215, 1)",
              },
              labelLine: {
                show: false,
              },
            },
          ],
        },
      ],
    };
  }
  //拆解中的轮播
  changeConSwipeIndex(index: any, params: any, go: any) {
    if (this.conSwipeIndex == index && go == 0) {
      this.$router.push({
        path: "/cjDetail",
        query: {
          reportId: params.reportId,
        },
      });
    }
    this.conSwipeIndex = index;
    (this.$refs.vanSwipe as any).swipeTo(index);
  }
}
